import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from "react-toastify";

import HomeCryptofacil from "./containers/HomeCryptofacil";
import Home from './containers/Home';
import PfContainer from "./containers/PfContainer";
import ZinliContainer from "./containers/ZinliContainer";
import Layout from './containers/Layout';
import Receive from './containers/Receive';
import SignupDecorate from "./containers/Signup";
import LoginCryptofacilDecorate from "./containers/LoginCryptofacil";

import './App.css';
import "./assets/scss/main.scss";
import "react-toastify/dist/ReactToastify.css";

function App() {
    return (
        <>
            <Router>
                <Routes>
                    <Route path="/" element={<Layout />} >
                        <Route path="/" element={<HomeCryptofacil />} />
                        <Route path="/cryptofacil/home" element={<Home />} />
                        <Route path="/cryptofacil/signup" element={<SignupDecorate />} />
                        <Route path="/cryptofacil/login" element={<LoginCryptofacilDecorate />} />
                        <Route path="/cryptofacil/zinli" element={<ZinliContainer />} />
                        <Route path="/cryptofacil/pf" element={<PfContainer />} />
                        <Route path="/cryptofacil/receive" element={<Receive />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Route>
                </Routes>
            </Router>
            <ToastContainer />
        </>
    );
}

export default App;
